import React from "react";
import { Box, VStack, Heading, Text, Button, SimpleGrid, HStack, Icon, Link } from "@chakra-ui/react";
import { FaRegClock, FaBolt, FaBalanceScale, FaSlidersH, FaUserCheck, FaMapMarkedAlt } from "react-icons/fa";
import Disclosurre from "./disclosurre";

const benefits = [
  {
    title: "Quick online application",
    icon: FaRegClock,
    desc: "Complete your loan application online in just a few minutes.",
  },
  {
    title: "Fast approval & instant cash",
    icon: FaBolt,
    desc: "Get a quick decision and fast funding for eligible applications in minutes, not days.",
  },
  {
    title: "Transparent and fair rates",
    icon: FaBalanceScale,
    desc: "Clear, upfront pricing so you know your borrowing costs before you accept. Our rates are among the best in Canada",
  },
  {
    title: "Flexible repayment terms",
    icon: FaSlidersH,
    desc: "Choose repayment options between 12 and 48 months to fit your budget and lifestyle.",
  },
  {
    title: "Bad credit accepted",
    icon: FaUserCheck,
    desc: "Past credit challenges do not automatically disqualify your application. At Swift Credit, we believe a credit score isn’t a fair reflection of your ability to repay, so we focus on other factors, such as regular income.",
  },
  {
    title: "Canada-wide",
    icon: FaMapMarkedAlt,
    desc: "We provide fast and easy access to short-term loans across Canada, except Quebec, Yukon, Nunavut, the Northwest Territories, and PEI. Whether you are in a remote village or a busy city, Swift Credit helps you get funds quickly.",
  },
];

export default function ShortTermLoan() {
  return (
    <>
      <Box width="100%" bg="gray.50" pt={{ base: 28, md: 32 }} pb={{ base: 12, md: 16 }} px={{ base: 4, md: 8 }}>
        <VStack maxW="1100px" mx="auto" spacing={8} align="stretch">
          <Box border="1px solid" borderColor="blackAlpha.400" borderRadius="2xl" px={{ base: 5, md: 8 }} py={{ base: 8, md: 10 }} bgGradient="linear(to-r, blue.50, white)" boxShadow="sm">
            <VStack spacing={4} textAlign="center">
              <Heading size="xl">Get a short-term loan between $500 and $20,000</Heading>
              <Text color="gray.700" maxW="860px">
                Choose a repayment period between 12 and 48 months with a fast, secure online process.
              </Text>
              {/*<Text textAlign="center" color="gray.700" fontSize="sm" px={{ base: 1, md: 4 }}>
                Want to borrow a smaller amount? Apply for {" "}
                <Link href="/payday-loan" color="blue.600" fontWeight="semibold" _hover={{ textDecoration: "underline" }}>
                  Swift payday loan
                </Link>
                .
              </Text>*/}
              <Button as="a" href="/apply" bg="black" color="white" borderRadius="full" px={10} h="50px" _hover={{ bg: "gray.900" }}>
                Get a Loan
              </Button>
            </VStack>
          </Box>

          <Box border="1px solid" borderColor="gray.200" borderRadius="2xl" px={{ base: 5, md: 8 }} pt={{ base: 8, md: 10 }} pb={{ base: 14, md: 16 }} bg="white" position="relative">
            <VStack spacing={3} textAlign="center" mb={6}>
              <Heading size="lg">Benefits of short-term loan</Heading>
              <Text color="gray.600">Designed to give you speed, flexibility, and confidence when borrowing.</Text>
            </VStack>

            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
              {benefits.map((benefit) => (
                <Box key={benefit.title} border="1px solid" borderColor="gray.200" borderRadius="xl" p={6} bg="white" textAlign="center" transition="all 0.2s ease" _hover={{ transform: "translateY(-2px)", boxShadow: "md", borderColor: "black" }}>
                  <HStack justify="center" mb={3}>
                    <Box w="52px" h="52px" borderRadius="full" bg="blue.50" border="1px solid" borderColor="blue.100" display="flex" alignItems="center" justifyContent="center">
                      <Icon as={benefit.icon} color="blue.700" boxSize={5} />
                    </Box>
                  </HStack>
                  <Text fontWeight="700" mb={2}>{benefit.title}</Text>
                  <Text color="gray.600" fontSize="sm">{benefit.desc}</Text>
                </Box>
              ))}
            </SimpleGrid>

            <Button
              as="a"
              href="/apply"
              bg="black"
              color="white"
              borderRadius="full"
              minW={{ base: "220px", md: "300px" }}
              px={10}
              h="50px"
              position="absolute"
              left="50%"
              bottom="0"
              transform="translate(-50%, 50%)"
              _hover={{ bg: "gray.900" }}
            >
              Get a Loan
            </Button>
          </Box>
        </VStack>
      </Box>
      <Disclosurre />
    </>
  );
}
